import React, { useState } from "react";

import { Link } from 'react-router-dom';

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Badge from "react-bootstrap/Badge";

import './Project.css'
import data from './data.json';

function Project_Bottom() {
    // State 변수를 추가하여 필터와 페이지 번호를 관리합니다.
    const [filter, setFilter] = useState("all"); // 초기값: "all"
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 9; // 페이지당 보여질 아이템 수

    // 데이터를 필터링하는 함수
    const filteredData = data.data.filter(item => {
        if (filter === "all") {
            return true; // 모든 항목을 보여줍니다.
        } else {
            return item.type === filter; // 선택된 타입과 일치하는 항목만 보여줍니다.
        }
    });

    // 페이지별로 데이터를 자릅니다.
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

    // 페이지네이션을 위한 페이지 번호 버튼을 생성합니다.
    const pageNumbers = [];
    for (let i = 1; i <= Math.ceil(filteredData.length / itemsPerPage); i++) {
        pageNumbers.push(i);
    }

    return (
        <>
            <Row style={{ marginTop: "30px" }}>
                <Col md={12} xs={12}>
                    <div className="text-center mb-3">
                        <Badge
                            className={(filter === "all" ? "bg-active" : "bg-white")}
                            onClick={() => setFilter("all")}
                            style={{ cursor: "pointer", marginRight: "10px" }}
                        >
                            All
                        </Badge>
                        <Badge
                            className={(filter === "web-dev" ? "bg-active" : "bg-white")}
                            onClick={() => setFilter("web-dev")}
                            style={{ cursor: "pointer", marginRight: "10px" }}
                        >
                            Web Dev
                        </Badge>
                        <Badge
                            className={(filter === "app-dev" ? "bg-active" : "bg-white")}
                            onClick={() => setFilter("app-dev")}
                            style={{ cursor: "pointer" }}
                        >
                            App Dev
                        </Badge>
                        <Badge
                            className={(filter === "data" ? "bg-active" : "bg-white")}
                            onClick={() => setFilter("data")}
                            style={{ cursor: "pointer" }}
                        >
                            Data
                        </Badge>
                    </div>
                </Col>
            </Row>
            <hr></hr>
            <Row>
                {currentItems.map((item, index) => (
                    <Col className="project-row" key={index} md={4} xs={12}>
                        <Button className="project-one" variant="white">
                            <Link className = "project-main" to={`/project-detail-eng/${item.id}`}>
                                <img className="project-img" src={item.src} alt={item.title}></img>
                                <p className="project-main">{item.description}</p>
                                <h5 className="project-main">{item.subtitle}</h5>
                                <hr></hr>
                                <h3 className="project-main">{item.title}</h3>
                            </Link>
                        </Button>
                    </Col>
                ))}
            </Row>
            <Row>
                <Col md={12} xs={12}>
                    <ul className="project-pagination pagination justify-content-center">
                        {pageNumbers.map(number => (
                            <li
                                key={number}
                                className={`page-item ${number === currentPage ? "active" : ""}`}
                            >
                                <button
                                    className="page-link"
                                    onClick={() => setCurrentPage(number)}
                                >
                                    {number}
                                </button>
                            </li>
                        ))}
                    </ul>
                </Col>
            </Row>
        </>
    )
}

export default Project_Bottom;
